var readMoreLess = function () {

  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  //
  // Settings
  //
  var settings = {
    speed: 300,
    activeClass: 'is-active',
    selector: '[data-more]',
    selectorFooter: '[data-more-footer]',
    selectorTrigger: '[data-more-trigger]',
    selectorContent: '[data-more-content]',
    // A second, separate copy of the copy. A block that has one is in "swap" mode: the
    // trigger hides the teaser above and slides this down in its place, rather than
    // growing the teaser to its own full height. Collapsed by _read_more.scss.
    selectorFull: '.full-content',
  };


  //
  // Methods
  //

  // Show
  var show = function (trigger, target, parent) {

    // Get the natural height of the element
    var getHeight = function () {
      var height = target.scrollHeight + 'px'; // Get it's height
      return height;
    };

    var height = getHeight(); // Get the natural height
    parent.classList.add(settings.activeClass); // Add active class to the parent element
    parent.querySelector(settings.selectorFooter)?.classList.add('open');
    target.style.height = height; // Update the max-height

    // Update the text
    var textLess = trigger.dataset.moreTextLess;
    trigger.textContent = textLess;

    // Once the transition is complete, remove the inline max-height so the content can scale responsively
    window.setTimeout(function () {
      target.style.height = '';
    }, settings.speed);

  };

  // Hide
  var hide = function (trigger, target, parent) {

    var heightDefined = target.dataset.moreHeight;

    // Give the element a height to change from
    target.style.height = target.scrollHeight + 'px';
    parent.classList.remove(settings.activeClass);  // Remove active class to the parent element
    parent.querySelector(settings.selectorFooter)?.classList.remove('open');

    // Update the text
    var textMore = trigger.dataset.moreTextMore;
    trigger.textContent = textMore;

    // Set the height back to defined height
    window.setTimeout(function () {
      target.style.height = heightDefined + 'px';
    }, 1);

  };

  // The height the teaser occupies when it is the one on show: whatever height it was
  // given (its defined clamp), or its own content height when that was `auto`. Read from
  // scrollHeight rather than a stored measurement so a resize while the block is open
  // doesn't leave the closing animation aiming at a stale number.
  var teaserHeight = function (teaser) {
    var held = teaser.dataset.moreCollapsedHeight;
    return held && held !== 'auto' ? parseFloat(held) : teaser.scrollHeight;
  };

  // Swap in — the full copy takes over the space the teaser was holding, then grows into
  // its own height. Only one box is ever animating: the teaser steps aside in one frame
  // (transitions off) and the full copy starts from exactly the height it vacated, so no
  // text shifts position and the block never jumps. All that visibly moves is the footer,
  // riding the bottom edge of the copy as it grows.
  var swapIn = function (trigger, teaser, full, parent) {

    // Re-opened before a close had finished: the teaser is already out of the way and its
    // held height is already recorded, so carry on from wherever the full copy got to
    // rather than restarting from a teaser that currently measures nothing.
    var reversing = teaser.offsetHeight === 0;
    var handover = reversing ? full.offsetHeight : teaser.offsetHeight;

    if (!reversing) {
      // Remember how the teaser was sized so swapping back can restore it exactly.
      teaser.dataset.moreCollapsedHeight = teaser.style.height;
      teaser.style.transition = 'none';
      teaser.style.height = '0px';
    }

    // Take up the teaser's height with transitions off, so the full copy *arrives* at that
    // starting point rather than animating up to it from its collapsed zero. Suppressing
    // the transition is what makes the browser commit the value: a forced reflow alone
    // leaves both heights in one style recalculation, and the block visibly collapses for
    // a frame before growing.
    full.style.transition = 'none';
    full.style.height = handover + 'px';
    void full.offsetHeight;
    full.style.transition = '';

    parent.classList.add(settings.activeClass);
    parent.querySelector(settings.selectorFooter)?.classList.add('open');

    full.style.height = full.scrollHeight + 'px';

    // Update the text
    trigger.textContent = trigger.dataset.moreTextLess;

    // Once it has arrived, hand the full copy back to `auto` so it stays responsive --
    // a fixed height from before a resize would clip it.
    window.setTimeout(function () {
      if (parent.classList.contains(settings.activeClass)) {
        full.style.height = 'auto';
      }
    }, settings.speed);

  };

  // Swap out — the reverse, and the same rule: the full copy shrinks back to exactly the
  // height the teaser needs and only hands over once it is there, so the teaser reappears
  // into a space already its own size. Nothing slides but the footer.
  var swapOut = function (trigger, teaser, full, parent) {

    var handover = teaserHeight(teaser);

    full.style.height = full.scrollHeight + 'px'; // off `auto`, so it has somewhere to go
    void full.offsetHeight;

    parent.classList.remove(settings.activeClass);
    parent.querySelector(settings.selectorFooter)?.classList.remove('open');

    full.style.height = handover + 'px';

    // Update the text
    trigger.textContent = trigger.dataset.moreTextMore;

    window.setTimeout(function () {
      if (parent.classList.contains(settings.activeClass)) return; // reopened mid-close

      // The hand-back, in one frame and with both transitions off. The full copy is sitting
      // at exactly the height the teaser is about to take, so swapping which one holds it
      // changes nothing on screen -- whereas letting the full copy transition down to its
      // collapsed zero from here would shrink the block a second time, under a teaser that
      // is already back, which is the sliding this is meant to avoid.
      full.style.transition = 'none';
      full.style.height = ''; // back to the collapsed height in _read_more.scss
      teaser.style.height = teaser.dataset.moreCollapsedHeight || '';
      void full.offsetHeight;
      full.style.transition = '';
      teaser.style.transition = '';
    }, settings.speed);

  };

  // Toggle
  var toggleContent = function (event, trigger) {

    // Variables
    var parent = event.target.closest(settings.selector),
      target = parent.querySelector(settings.selectorContent),
      full = parent.querySelector(settings.selectorFull);

    // If the element is visible, hide it
    if (parent.classList.contains(settings.activeClass)) {
      full ? swapOut(trigger, target, full, parent) : hide(trigger, target, parent);
      return;
    }

    // Otherwise, show it
    full ? swapIn(trigger, target, full, parent) : show(trigger, target, parent);

  };

  // Destroy. When the content is shorter, reset height to auto and remove footer button.
  // Elements hidden at measurement time (display:none, e.g. behind a "See More" toggle)
  // report scrollHeight 0, so skip them here — call refresh() once they're visible instead.
  var destroy = function (elem) {
    for (var i = 0; i < elem.length; i++) {
      var el = elem[i],
        heightDefined = parseInt(el.dataset.moreHeight),
        parent = el.closest(settings.selector),
        footer = parent.querySelector(settings.selectorFooter),
        full = parent.querySelector(settings.selectorFull);

      // Measure natural content height with no height constraint
      var savedHeight = el.style.height;
      el.style.height = 'auto';
      var naturalHeight = el.scrollHeight;
      el.style.height = savedHeight;

      if (naturalHeight <= 0) continue;

      var fits = naturalHeight <= heightDefined + 50;
      if (fits) el.style.height = 'auto';

      // Swap mode: a teaser that fits says nothing about whether there is more to read,
      // since the full copy is a separate block rather than the rest of this one. What
      // retires the trigger here is the full copy having no more to show than the teaser
      // it would replace. (It measures while collapsed -- height:0 with overflow hidden
      // still reports its content height.)
      if (full) {
        if (full.scrollHeight <= naturalHeight) footer.style.display = 'none';
        continue;
      }

      if (fits) footer.style.display = 'none';
    }
  };

  // Re-run the destroy check on demand, scoped to a root element. Use this after
  // revealing content that was display:none (and thus unmeasurable) on init.
  var refresh = function (root) {
    var scope = root || document;
    destroy(scope.querySelectorAll(settings.selectorContent));
  };

  // Click Handler
  var clickHandler = function (event) {

    // Only run if clicked element matches our selector
    var trigger = event.target.closest(settings.selectorTrigger);
    if (trigger) {

      // Prevent default link behavior
      event.preventDefault();          

      // Toggle Content
      toggleContent(event, trigger);
    }

  };


  //
  // Inits & Event Listeners
  //

  // Toggle content on click
  document.addEventListener('click', clickHandler, false);

  // Destroy when the real content is shorter than defined height.
  // Defer to after fonts load so scrollHeight is accurate.
  var contentElements = document.querySelectorAll(settings.selectorContent);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { destroy(contentElements); });
  } else {
    destroy(contentElements);
  }

  // Expose for content revealed after init (e.g. behind a "See More" toggle),
  // where the elements were display:none and unmeasurable during the init pass above.
  window.refreshReadMore = refresh;

};

readMoreLess();